import Heading from '../atoms/Heading';
import Icon from '../atoms/Icon';
import ButtonGroup from './ButtonGroup';

function SmallDrawer({
  show,
  title = 'title',
  onClose = () => { },
  onSave,
  children,
  isFooter = false,
  cancelLabel = 'Cancel',
  saveLabel = 'Save',
  isDisabled = false,
  drawerHeight = 'md:h-[150px]'
}) {
  if (!show) return null;
  const buttons = [

    {
      label: saveLabel,
      kind: 'primaryLoud',
      onClick: onSave,
      isDisabled: isDisabled
    },
    {
      label: cancelLabel,
      kind: 'silent',
      color: 'green',
      onClick: onClose,
    }
  ];

  return (
    <div className='fixed top-0 md:top-12 right-0 h-screen md:h-[calc(100vh-3rem)] bg-black bg-opacity-40 z-[111] w-full flex justify-end'>
      <div className={`h-full bg-white w-full max-w-[680px] flex flex-col ${drawerHeight} bottom-0 absolute`}>
        <div className='flex-none flex items-center justify-between mb-4 px-5 py-4'>
          <Heading type='h4'>{title}</Heading>
          <Icon icon='close__l__stroke' color='black' className='cursor-pointer' onClick={onClose} />
        </div>
        <div className='flex-1 overflow-y-auto px-5 pb-6 scroll-hidden'>
          {children}
        </div>
        {
          isFooter && (
            <div className='flex p-6 flex-start'>
              <ButtonGroup buttons={buttons} />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default SmallDrawer